import { graphql } from "@/graphql/generated/gql";

export const suggestClimateActionsMutationDocument = graphql(/* GraphQL */ `
  mutation SuggestClimateActions($input: SuggestClimateActionsInput!) {
    suggestClimateActions(input: $input) {
      jobId
    }
  }
`);

export const cancelSuggestionJobMutationDocument = graphql(/* GraphQL */ `
  mutation CancelSuggestionJob($jobId: String!) {
    cancelSuggestionJob(jobId: $jobId)
  }
`);

export const suggestionJobQueryDocument = graphql(/* GraphQL */ `
  query SuggestionJob($jobId: String!) {
    suggestionJob(jobId: $jobId) {
      jobId
      status
      response {
        requestId
        warning
        stale
        inventoryYear
        inventoryCount
        inventoryAgeYears
        inventoryStaleness
        suggestions {
          sourceId
          title
          descriptionText
          descriptionJson
          focusAreaName
          sectorTags
          reasoning
          scoring {
            score
            crossBonus
            winningSector
            sectors {
              sector
              lever
              sharePct
              annualDeltaPct
              emissionContribution
              trendContribution
              gapContribution
              activeCount
              subsectorShare
              subsectorBoost
            }
          }
        }
      }
    }
  }
`);

export const cachedClimateActionSuggestionsQueryDocument = graphql(/* GraphQL */ `
  query CachedClimateActionSuggestions(
    $workspaceId: String!
    $includeInventory: Boolean
    $applyPreFilter: Boolean
  ) {
    cachedClimateActionSuggestions(
      workspaceId: $workspaceId
      includeInventory: $includeInventory
      applyPreFilter: $applyPreFilter
    ) {
      requestId
      warning
      stale
      inventoryYear
      inventoryCount
      inventoryAgeYears
      inventoryStaleness
      suggestions {
        sourceId
        title
        descriptionText
        descriptionJson
        focusAreaName
        sectorTags
        reasoning
        scoring {
          score
          crossBonus
          winningSector
          sectors {
            sector
            lever
            sharePct
            annualDeltaPct
            emissionContribution
            trendContribution
            gapContribution
            activeCount
            subsectorShare
            subsectorBoost
          }
        }
      }
    }
  }
`);

export const rejectClimateActionSuggestionMutationDocument = graphql(/* GraphQL */ `
  mutation RejectClimateActionSuggestion($input: RejectSuggestionInput!) {
    rejectClimateActionSuggestion(input: $input)
  }
`);

export const undoRejectClimateActionSuggestionMutationDocument = graphql(/* GraphQL */ `
  mutation UndoRejectClimateActionSuggestion($input: UndoRejectSuggestionInput!) {
    undoRejectClimateActionSuggestion(input: $input)
  }
`);

export const recordSuggestionFeedbackMutationDocument = graphql(/* GraphQL */ `
  mutation RecordSuggestionFeedback($input: RecordSuggestionFeedbackInput!) {
    recordSuggestionFeedback(input: $input)
  }
`);

export const activeRejectedSuggestionsQueryDocument = graphql(/* GraphQL */ `
  query ActiveRejectedSuggestions($workspaceId: String!) {
    activeRejectedSuggestions(workspaceId: $workspaceId)
  }
`);

export const latestSuggestionJobQueryDocument = graphql(/* GraphQL */ `
  query LatestSuggestionJob($workspaceId: String!) {
    latestSuggestionJob(workspaceId: $workspaceId) {
      jobId
      status
      response {
        requestId
        warning
        stale
        inventoryYear
        inventoryCount
        inventoryAgeYears
        inventoryStaleness
        suggestions {
          sourceId
          title
          descriptionText
          descriptionJson
          focusAreaName
          sectorTags
          reasoning
          scoring {
            score
            crossBonus
            winningSector
            sectors {
              sector
              lever
              sharePct
              annualDeltaPct
              emissionContribution
              trendContribution
              gapContribution
              activeCount
              subsectorShare
              subsectorBoost
            }
          }
        }
      }
    }
  }
`);

export const previewClimateActionSuggestionPromptQueryDocument = graphql(/* GraphQL */ `
  query PreviewClimateActionSuggestionPrompt($input: PreviewSuggestionPromptInput!) {
    previewClimateActionSuggestionPrompt(input: $input) {
      systemPrompt
      userPrompt
      promptVersion
      catalogSize
      includedInventory
      model
    }
  }
`);
